export default {
  methods: {
    getGroupList(return_data, all) {
      let datas = [{
        value: '',
        label: '전체'
      }];
      let url = 'public/group/simple';
      if(this.$store.getters.mode==='superpartner')
        url=`superpartner/${this.$store.getters.superpartner.user_id}/group/simple`;
      else if(this.$store.getters.mode==='partner')
        url=`partner/${this.$store.getters.partner.partner_id}/group/simple`;
      this.$axios.get(url).then(res => {
        if(all!==undefined && all===true) {
          this[return_data] = datas.concat(res.data);
        }
        else {
          this[return_data] = res.data;
        }
      })
    }
  }
}
